import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTime } from "luxon";

interface JobRunDayFieldProps {
  label: string;
  /** The day in `format`, or "" for none. */
  value: string;
  /** How the day is written in the input: "yyMMdd" or "yyyy-MM-dd". */
  format: string;
  onChange: (value: string) => void;
  helperText?: string;
  disableFuture?: boolean;
}

/** A day picker for a job's settings, reading and writing the day as text in `format`. */
export const JobRunDayField = (props: JobRunDayFieldProps) => {
  const { label, value, format, onChange, helperText, disableFuture = false } = props;
  let picked: DateTime | null = null;
  if (value) picked = DateTime.fromFormat(value, format);

  const handleChange = (day: DateTime | null) => {
    let text = "";
    if (day && day.isValid) text = day.toFormat(format);
    onChange(text);
  };

  return (
    <DatePicker
      disableFuture={disableFuture}
      label={label}
      onChange={handleChange}
      slotProps={{ textField: { fullWidth: true, helperText, size: "small" } }}
      value={picked}
    />
  );
};
